import type { IconType } from "react-icons";

/** A `FormGroup` title with a small leading icon — used by every `/tiers` form for a quick visual anchor per section. */
export function SectionTitle({ icon: Icon, children }: { icon: IconType; children: string }) {
  return (
    <span className="inline-flex items-center gap-2">
      <Icon aria-hidden className="size-4 text-primary" />
      {children}
    </span>
  );
}
